import { InfoFilled } from "@fluentui/react-icons";

const DeletePayoutConfirmation = () => {
  return (
    <div className="flex flex-col gap-4 md:mt-8 mt-4">
      <div className="flex justify-center">
        <InfoFilled
          fontSize={120}
          color="#FFA94D"
          className="!z-50 bg-lightOrange text-6xl text-center rounded-full p-2"
        />
      </div>
      <p className="text-center font-semibold text-lg ">
        Are You Sure You Want to Delete?
      </p>
      <p className="text-center text-base">
        By deleting, you will not be able to take out money{" "}
      </p>
    </div>
  );
};

export default DeletePayoutConfirmation;
